import React, { useState } from 'react';
import { Grid, Card, CardContent, CardHeader, TextField, Button, Typography, Switch, FormControlLabel, MenuItem, Avatar, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

export default function CreateZone({ companyid, onSuccess, onCancel }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('');
  const [classification, setClassification] = useState('');
  const [region, setRegion] = useState('');
  const [isMonitored, setIsMonitored] = useState(false);
  const [centar, setCentar] = useState('{"lat": 43.84675086032801, "lng": 18.343458329238622}');

  const navigate = useNavigate();

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const postData = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/api/zonas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          companyid: 1,
          name,
          description,
          type,
          classification,
          region,
          isMonitored,
          centar
        })
      });

      if (!response.ok) {
        console.error("Greška API poziva:", await response.text());
        return;
      }

      if (onSuccess) onSuccess();

    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ backgroundColor: '#00122E', width: '100%', padding: '20px' }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 600, width: '100%', backgroundColor: '#00122E', color: '#ffffff', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60 }}>Zona</Avatar>}
            title={<Typography variant="h6" sx={{ color: '#ffffff' }}>Nova zona</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Naziv zone"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Opis"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  select
                  label="Tip"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  SelectProps={{ style: { color: '#ffffff' } }}
                >
                  <MenuItem value="stambena">Stambena</MenuItem>
                  <MenuItem value="industrijska">Industrijska</MenuItem>
                  <MenuItem value="mješovita">Mješovita</MenuItem>
                  <MenuItem value="poljoprivredna">Poljoprivredna</MenuItem>
                  <MenuItem value="poslovna">Poslovna</MenuItem>
                </TextField>
                <TextField
                  select
                  label="Klasifikacija"
                  value={classification}
                  onChange={(e) => setClassification(e.target.value)}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  SelectProps={{ style: { color: '#ffffff' } }}
                >
                  <MenuItem value="urban">Urban</MenuItem>
                  <MenuItem value="suburban">Suburban</MenuItem>
                  <MenuItem value="rural">Rural</MenuItem>
                </TextField>
                <TextField
                  label="Regija"
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <FormControlLabel
                  control={<Switch checked={isMonitored} onChange={(e) => setIsMonitored(e.target.checked)} sx={{ color: '#fff' }} />}
                  label={<Typography sx={{ color: '#fff' }}>Monitorirana zona</Typography>}
                />
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
             <Button
                variant="outlined"
                sx={{ color: '#fff', borderColor: '#3949ab' }}
                onClick={onCancel} 
              >
                Odustani
              </Button>
              <Button
                variant="outlined"
                sx={{ color: '#fff', borderColor: '#3949ab' }}
                onClick={postData}
              >
                Spasi
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
